import styled from 'styled-components';
import { Stack, getSpacingToken, getToken } from '@optimus-web/core';

export const OffsetStack = styled(Stack)<{ offset?: number }>`
    padding-top: ${getSpacingToken('100')}px;
    padding-bottom: ${getSpacingToken('100')}px;
    padding-left: ${({ offset, theme }) => (offset ?? 0) * getSpacingToken('300')({ theme })}px;
    border-bottom: 1px solid ${getToken('paletteBrandNight50')};
    ${(props) => (props.onClick !== undefined ? 'cursor: pointer;' : '')}
`;
